<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="autorizarGuiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="guia && dados">
                    <div class="modal-header">
                        <h5 class="modal-title">Autorizar Guia</h5>
                            <button type="button" class="close" @click="fechar()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <table class="table table-sm mb-0">
                                <tr>
                                    <td><i class="fa fa-credit-card-alt fa-fw mr-2"></i>Operadora</td>
                                    <td>
                                        <div>{{ dados.plano.search }}</div>
                                        <small class="text-muted" v-if="guia.contrato_operadora && guia.contrato_operadora.st_numero_prestador">
                                            {{ guia.contrato_operadora.st_descricao_arquivo_contrato }}:
                                            {{ guia.contrato_operadora.st_numero_prestador }}:
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <td><i class="far fa-file-alt fa-fw mr-2"></i>Número da Guia do Prestador</td>
                                    <td>
                                        <span v-if="guia.st_numero_interno">
                                            <a class="lead" href="#" @click.prevent="copiar_clipboard(guia.st_numero_interno)" 
                                                data-toggle="tooltip" data-placement="top" title="Copiar para o área de transferência.">
                                                <i class="far fa-copy mr-2"></i>
                                            </a>
                                            {{ guia.st_numero_interno }}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><i class="fas fa-id-card-alt fa-fw mr-2"></i>Matrícula</td>
                                    <td>
                                        <span v-if="dados.atendimento.st_numero_carteira">
                                            <a class="lead" href="#" @click.prevent="copiar_clipboard(dados.atendimento.st_numero_carteira)" 
                                                data-toggle="tooltip" data-placement="top" title="Copiar para o área de transferência.">
                                                <i class="far fa-copy mr-2"></i>
                                            </a>
                                            {{ dados.atendimento.st_numero_carteira }}
                                        </span>
                                        <small class="text-muted ml-3" v-if="dados.atendimento.dt_validade_carteira">
                                            Val.: {{ $util.getFormatDate(dados.atendimento.dt_validade_carteira) }}
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <td><i class="fas fa-user-md fa-fw mr-2"></i>Executante</td>
                                    <td>{{ dados.atendimento.medico.st_nome_exibicao }} / {{ dados.atendimento.medico.in_numero_conselho }}</td>
                                </tr>
                                <tr v-if="dados.atendimento.medico_solicitante">
                                    <td><i class="fas fa-user-md fa-fw mr-2"></i>Solicitante</td>
                                    <td>
                                        {{ dados.atendimento.medico_solicitante.search }} 
                                    </td>
                                </tr>
                                <tr v-if="dados.atendimento.cid">
                                    <td><i class="fas fa-comment-medical fa-fw mr-2"></i>CID</td>
                                    <td>
                                        {{ dados.atendimento.cid.st_codigo }} 
                                        <span v-if="dados.atendimento.dt_solicitacao">
                                            em {{ $util.getFormatDate(dados.atendimento.dt_solicitacao.substr(0,10)) }}
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <h3 class="d-flex justify-content-center mb-3">
                            <a v-if="dados.plano.operadora.st_site" class="card-link" :href="dados.plano.operadora.st_site"
                                target="_blank">
                                Acessar Site da Operadora
                            </a>
                        </h3>
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    icon="fas fa-asterisk fa-fw"
                                    buttonToolTip="Senha de Autorização"
                                    placeholder="Senha..."
                                    v-model="guia.st_codigo_autorizacao" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    icon="fas fa-plus fa-fw"
                                    buttonToolTip="Data da Autorização"
                                    type="date"
                                    :required="guia.st_codigo_autorizacao ? true : false"
                                    :edicao="guia.st_codigo_autorizacao ? true : false"
                                    v-model="guia.dt_autorizacao" 
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    icon="fas fa-check fa-fw"
                                    buttonToolTip="Validade da Autorização"
                                    type="date"
                                    :edicao="guia.st_codigo_autorizacao ? true : false"
                                    :required="guia.st_codigo_autorizacao ? true : false"
                                    v-model="guia.dt_validade_autorizacao" 
                                    :validate="validate" />
                            </div>
                        </div>
                        <table class="table table-sm small mt-3 mb-0">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Descrição</th>
                                    <th>Tabela</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(apg, iax) in guia.atendimento_procedimento_guias" :key="iax"> 
                                    <td>
                                        <span v-if="apg.item_tabela" class="text-nowrap">
                                            <a class="lead" href="#" @click.prevent="copiar_clipboard(apg.item_tabela.st_codigo)" 
                                                data-toggle="tooltip" data-placement="top" title="Copiar para o área de transferência.">
                                                <i class="far fa-copy mr-2"></i>
                                            </a>
                                            {{ apg.item_tabela.st_codigo }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="apg.item_tabela">
                                            {{ apg.item_tabela.st_nome }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="apg.codigo_tabela">
                                            {{ apg.codigo_tabela.ch_codigo }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        {{ $util.formatMoeda(apg.in_quantidade * apg.dc_valor) }}
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </table>

                        <template v-if="false">
                            <pre class="alert alert-secondary">{{ dados }}</pre>
                            <pre class="alert alert-warning">{{ guia }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            guia: null, 
            validate: false, 
            dados: null, 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    props: ['marcacao'],

    methods: { 
        copiar_clipboard (text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Código '" + text + "' copiado para a área de transferência.",
                life: 3000
            });
        },

        fechar() { 
            $('#autorizarGuiaModal').modal('hide');
        },

        abrir(guia) { 
            console.log('guia', guia);
            this.guia = _.cloneDeep(guia);
            this.dados = _.cloneDeep(this.marcacao);
            $('#autorizarGuiaModal').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'atualizar_senha',
                dados: { 
                    id_guia: this.guia.id_guia, 
                    st_codigo_autorizacao: this.guia.st_codigo_autorizacao,
                    dt_autorizacao: this.guia.dt_autorizacao,
                    dt_validade_autorizacao: this.guia.dt_validade_autorizacao
                },
                toast: true, 
                modal: 'autorizarGuiaModal',
                callback: () => { 
                    this.guia = null;
                    this.dados = null;
                    this.$emit('refresh');
                }
            });
        },
    }
}
</script>